/* global Swiper */
(() => {
  const initTopCategoriesCarousel = () => {
    document.querySelectorAll('.top-categories-carousel-swiper').forEach((swiperEl) => {
      const sectionId = swiperEl.id;
      const section = swiperEl.closest('.carousel-utils_container__rdttZ');
      if (!section) return;

      const isCentered = section.classList.contains('top-categories-carousel-container--centered');
      const prevButton = section.querySelector('.top-categories-carousel-arrow--left');
      const nextButton = section.querySelector('.top-categories-carousel-arrow--right');

      // Wait for images to load before initializing
      const waitForImages = (callback) => {
        const images = section.querySelectorAll('.links-carousel_imgWrapper__OON6Y img');
        if (images.length === 0) {
          callback();
          return;
        }

        let loadedCount = 0;
        const totalImages = images.length;

        const checkComplete = () => {
          loadedCount++;
          if (loadedCount === totalImages || document.readyState === 'complete') {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                callback();
              });
            });
          }
        };

        images.forEach((img) => {
          if (img.complete) {
            checkComplete();
          } else {
            img.addEventListener('load', checkComplete, { once: true });
            img.addEventListener('error', checkComplete, { once: true });
          }
        });

        setTimeout(() => {
          if (loadedCount < totalImages) {
            callback();
          }
        }, 500);
      };

      waitForImages(() => {
        const swiper = new Swiper(`#${CSS.escape(sectionId)}`, {
          slidesPerView: 'auto',
          spaceBetween: 0,
          grabCursor: true,
          freeMode: false,
          allowTouchMove: true,
          resizeObserver: false,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          on: {
            init: function () {
              updateArrowStates(this);
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  centerSlidesIfNeeded(this);
                });
              });
            },
            slideChange: function () {
              updateArrowStates(this);
              if (isCentered && window.innerWidth >= 640) {
                setTimeout(() => {
                  centerSlidesIfNeeded(this);
                }, 10);
              }
            },
            resize: function () {
              setTimeout(() => {
                centerSlidesIfNeeded(this);
                updateArrowStates(this);
              }, 100);
            },
          },
        });
      });

      function centerSlidesIfNeeded(swiperInstance) {
        // CSS handles centering, we just need to ensure swiper can work
        // Don't reset transforms or disable swiper - let it work normally
        swiperInstance.allowTouchMove = true;
        swiperInstance.allowSlideNext = true;
        swiperInstance.allowSlidePrev = true;
      }

      function updateArrowStates(swiperInstance) {
        const shouldDisableArrows = () => {
          if (!isCentered || window.innerWidth < 640) return false;

          const slides = swiperInstance.slides;
          const container = swiperInstance.el;
          const containerWidth = container.clientWidth;

          let totalWidth = 0;
          slides.forEach((slide, index) => {
            const slideRect = slide.getBoundingClientRect();
            const slideStyle = window.getComputedStyle(slide);
            const slideWidth = slideRect.width;
            const slideMarginRight = (index < slides.length - 1) ? parseFloat(slideStyle.marginRight) || 0 : 0;
            totalWidth += slideWidth + slideMarginRight;
          });

          return totalWidth <= containerWidth;
        };

        if (prevButton) {
          prevButton.disabled = swiperInstance.isBeginning || shouldDisableArrows();
        }
        if (nextButton) {
          nextButton.disabled = swiperInstance.isEnd || shouldDisableArrows();
        }
      }
    });
  };

  const runInit = () => {
    if (typeof Swiper !== 'undefined') {
      initTopCategoriesCarousel();
    } else {
      document.addEventListener('swiper-loaded', initTopCategoriesCarousel, { once: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit);
  } else {
    runInit();
  }

  window.addEventListener('load', () => {
    setTimeout(() => {
      initTopCategoriesCarousel();
    }, 100);
  });
})();

